export default (test, root) => root && test instanceof root;
